// extracted by mini-css-extract-plugin
export default {"wrap":"ButtonEclipse_wrap__2jVAN","button":"ButtonEclipse_button__Jjcyl"};